import { AbstractControl, ValidatorFn } from '@angular/forms';
import { isEmptyString, isNil } from '@web/utils';
import { ValidationError } from '../enums/validation-error';

export class EmailValidator {
  public static email = ((): ValidatorFn => {
    // RFC 5322 Official Standard
    const regExp = new RegExp(
      `^(?:[A-z0-9!#$%&'*+/=?^_\`{|}~-]+(?:\\.[A-z0-9!#$%&'*+/=?^_\`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[A-z0-9](?:[A-z0-9-]*[A-z0-9])?\\.)+[A-z0-9](?:[A-z0-9-]*[A-z0-9])?|\\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[A-z0-9-]*[A-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)])$`,
    );

    return (control: AbstractControl) => {
      const { value } = control;

      if (isNil(value)) {
        return null;
      }

      if (isEmptyString(value)) {
        return null;
      }

      const isValid = regExp.test(value);

      if (isValid) {
        return null;
      }

      return {
        [ValidationError.Email]: true,
      };
    };
  })();
}
